var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    viewBox: "0 0 356 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9 149.6L54.1 159.9L47.4 172.6V247.9L48.5 259.4L42.4 270.3L113.6 316.1L292.2 306.6L294.6 304.4L346.5 220.9L348.2 215.1L269.1 112.2L105.1 115.4L50.9 149.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.1 218.9C266.1 180.4 123.1 168.1 49.2 169.3L54.2 159.9H355C355.6 179.7 352.7 199.8 347.1 218.9Z",
    fill: "url(#paint0_linear_29_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.9 258.4C321 276.1 308.5 292.3 293.3 305.6C214.7 278.3 110.9 268.4 43.8 267.8L48.6 259.3H32.1L32.6 258.5H330.9V258.4Z",
    fill: "url(#paint1_linear_29_19)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 267.8C110.9 268.4 214.7 278.3 293.3 305.6C292.3 306.5 291.3 307.3 290.3 308.2C258 334.9 215 343.7 174 343.4C117.9 343 61.6 342.3 5.29998 342.3H2.09998L43.8 267.8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 259.4H1.40002L49.1 169.4C123 168.2 266 180.5 347 219C344.2 228.7 340.6 238.1 336.4 247.2C334.6 251.1 332.8 254.9 330.8 258.6",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 159.9C0.5 159.9 99.2 7.09999 101 3.99999C101.9 2.39999 103 1.59999 104.9 1.59999C118.8 1.19999 132.7 0.499995 146.6 0.399995C168.2 0.199995 189.7 1.89999 211 5.99999C273.6 18 332.8 63 350 126C350.9 129.2 351.6 132.4 352.3 135.7C353.9 143.7 354.8 151.8 355.1 159.9H0.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_19",
    x1: 195.036,
    y1: 264.845,
    x2: 219.548,
    y2: -60.8179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7586
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_19",
    x1: 175.508,
    y1: 338.501,
    x2: 197.782,
    y2: 42.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1994,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7783
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b7dcf940b5b469a9dbf5d8005e4affeb.svg";
export { ForwardRef as ReactComponent };